// Translations dictionary for IT · EN · RU · FR · DE
// All strings organised by page. Missing keys fall back to Italian.

import it from "./locales/it";
import en from "./locales/en";
import ru from "./locales/ru";
import fr from "./locales/fr";
import de from "./locales/de";

export const dictionaries = { it, en, ru, fr, de };

export const LANGS = [
  { code: "it", label: "Italiano", short: "IT" },
  { code: "en", label: "English", short: "EN" },
  { code: "ru", label: "Русский", short: "RU" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "de", label: "Deutsch", short: "DE" },
];
